const $ = require('../sukoa-jquery.cjs');

function Filter(list, $filter) {
    this.list = list;
    this.$domElt = $filter;
    this.name = $filter.attr("id");
    this.$styledSelect = $("#styled-"+this.name);
    this.defaultValue = "0";
    this.activeValues = null; //a string if filter type is select, an array otherwise
    this.$checkboxes = null;
    this.idsLabelsTab = {};

    if (this.$domElt.find("option").length > 0) {
        this.type = "select";
    } else if (this.$domElt.find('input[type="text"], input[type="search"]').length > 0) {
        this.type = "text";
        this.$searchInput = this.$domElt.find('input[type="text"], input[type="search"]');
        this.$searchReset = this.$domElt.find('.reset-icon');
        this.$searchIcon = this.$domElt.find('.search-icon');
    } else {
        this.type = "checkboxes";
    }
}

Filter.prototype.toggleSearchInputIcon = function(value) {
    if (value !== '') {
        this.$searchReset.css('display', 'block');
        this.$searchIcon.css('display', 'none');
    } else {
        this.$searchReset.css('display', 'none');
        this.$searchIcon.css('display', 'flex');
    }
}

Filter.prototype.isSelect = function() {
    return this.type === "select";
};

Filter.prototype.isSearch = function() {
    return this.type === "text";
};

Filter.prototype.isActive = function() {
    if (this.isSelect() || this.isSearch()) {
        return this.activeValues !== this.defaultValue;
    } else {
        return this.activeValues.length > 0;
    }
};

Filter.prototype.updateValues = function(value) {
    let self = this;
    if(self.isSelect()) {
        self.activeValues = value ?? self.$domElt.val();
    } else if(self.isSearch()) {
        self.activeValues = value ?? self.$searchInput.val()
    } else {
        self.activeValues = [];
        let $checkbox = self.$domElt.find(':checkbox:checked');
        $checkbox.each(function(){
            self.activeValues.push($(this).val());
        });
    }
};

Filter.prototype.listenChangeOnStyledFilter = function () {
    let self = this;
    let $selectedValue = self.$styledSelect.find("p.selected");
    let $lioptions = self.$styledSelect.find(".filteroptions li");
    let timer = null;
    self.$styledSelect.click(function(){
        self.$styledSelect.toggleClass("active");
    });

    self.$styledSelect.mouseleave(function(){
        if(self.$styledSelect.hasClass("active")) {
            timer = window.setInterval(function(){
                self.$styledSelect.removeClass("active");
                clearInterval(timer);
                timer = null;
            }, 1000);
        }
    });

    self.$styledSelect.mouseenter(function(){
        if(timer !== null) {
            clearInterval(timer);
            timer = null;
        }
    });

    $lioptions.click(function(e) {

        if($(this).attr("data-value") !== self.activeValues && !$(this).hasClass("disabled")) {
            $lioptions.removeClass("active");
            $(this).addClass("active");
            self.activeValues = $(this).attr("data-value");
            $selectedValue.text($(this).text());
            self.list.applyFilters();
        }
    });

};

Filter.prototype.changeStateListener = function() {
    let self = this;
    if(self.isSelect()) {
        self.$domElt.on("change", function() {
            self.updateValues();
            self.list.applyFilters();
        });

        self.listenChangeOnStyledFilter();
    } else if(self.isSearch()) {
        this.$searchInput.on("input", function() {
            self.updateValues();
            self.list.applyFilters();
        });
        this.$searchReset.on("click", function() {
            self.$searchInput.val("");
            self.updateValues("");
            self.list.applyFilters();
        });
    } else {
        self.$checkboxes.click(function() {
            let $label = $(this).parent("label");
            if(!$label.hasClass("disabled")) {
                $label.toggleClass("active");
                if($label.hasClass("active")){
                    $(this).attr("checked", true);
                } else{
                    $(this).attr("checked", false);
                }
                self.updateValues();
                self.list.applyFilters();
            }
        });
    }
};

Filter.prototype.printInfo = function() {
    console.log(this.type);console.log(this.activeValues);
};

Filter.prototype.normalizeSearchQuery = function (query) {
    return query
        .toLowerCase()
        .replace(/ß/g, 'ss')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '') // Remove accents
        .replace(/[^a-z0-9#]/g, '')      // Keep only a-z, 0-9, and #
        .trim();
};

Filter.prototype.filterElement = function(element) {
    const searchValue = this.activeValues;

    if(this.isActive()) {
        if(this.isSelect()) {
            return element.categories.indexOf(searchValue) !== -1;
        } else if(this.isSearch()) {
            this.toggleSearchInputIcon(searchValue);
            const searchAttributes = element.$domElt.attr('data-search');
            return this.normalizeSearchQuery(searchAttributes).includes(this.normalizeSearchQuery(searchValue));
        } else {
            let areUThatCool = false;
            for(let av in searchValue) {
                areUThatCool = element.categories.indexOf(searchValue[av]) !== -1;
                if(areUThatCool) {
                    break;
                }
            }
            return areUThatCool;
        }
    } else {
        return true;
    }
};

Filter.prototype.findIdFromLabel = function(label) {
    for(let id in this.idsLabelsTab) {
        if(label === this.idsLabelsTab[id]) {
            return id;
        }
    }
};

Filter.prototype.updateFromUrlParams = function(params) {
    if(this.isSelect()) {
        let $oldAtiveLiOptions = this.$styledSelect.find('.filteroptions li.active');
        if($oldAtiveLiOptions.size()>0){
            $oldAtiveLiOptions.removeClass("active");
            this.$styledSelect.find("p.selected").text(this.$styledSelect.find('.filteroptions li[data-value="'+this.defaultValue+'"]').text());
            this.$domElt.val(this.defaultValue);
            this.activeValues = this.defaultValue;
        }


        for(let p in params) {
            let selectedoption = this.$domElt.find('option[value="'+this.findIdFromLabel(params[p])+'"]');
            if(selectedoption.size()>0) {
                this.activeValues = this.findIdFromLabel(params[p]);
                this.$domElt.val(this.findIdFromLabel(params[p]));
                let $selectedValue = this.$styledSelect.find("p.selected");
                let $activeLiOption = this.$styledSelect.find('.filteroptions li[data-value="'+this.findIdFromLabel(params[p])+'"]');
                $activeLiOption.addClass("active");
                $selectedValue.text($activeLiOption.text());
                break;
            }
        }
    } else if (this.isSearch()) {
        const params = new URLSearchParams(window.location.search)
        const searchValue = params.get('search')
        if (searchValue) {
            this.activeValues = searchValue;
            this.$searchInput.val(searchValue);
        }
    } else {
        let $checkbox = this.$domElt.find(':checkbox');
        let self = this;
        $checkbox.each(function(){
            if(params.indexOf(self.idsLabelsTab[$(this).val()]) !== -1) {
                $(this).parent("label").addClass("active");
                $(this).attr("checked", true);
                self.activeValues.push($(this).val());
            } else if(self.activeValues.indexOf($(this).val()) !== -1){
                $(this).parent("label").removeClass("active");
                $(this).attr("checked", false);
                self.activeValues.splice(self.activeValues.indexOf($(this).val()), 1);
            }
        });
    }
};

Filter.prototype.updateOptions = function(usedTags) {
    let self = this;
    let oneFilterActiveAndItsMe = this.list.countActiveFilters() === 1 && this.isActive();
    if(this.isSelect()) {
        let $lioptions = self.$styledSelect.find(".filteroptions li");
        $lioptions.each(function() {
            if(usedTags.indexOf($(this).attr("data-value")) === -1 && !oneFilterActiveAndItsMe) {
                if(!$(this).hasClass("disabled")) {
                    $(this).addClass("disabled")
                }
            } else {
                if($(this).hasClass("disabled")) {
                    $(this).removeClass("disabled")
                }
            }
        });

        let $normalOptions = self.$domElt.find("option");
        $normalOptions.each(function() {
            if(usedTags.indexOf($(this).val()) === -1) {
                $(this).prop("disabled", true);
            } else {
                $(this).prop("disabled", false);
            }
        });

    } else if(!this.isSearch()) {
        if(!oneFilterActiveAndItsMe) {
            self.$checkboxes.each(function(){
                let $label = $(this).parent("label");
                if(usedTags.indexOf($(this).val()) === -1) {
                    if(!$label.hasClass("disabled") && !$label.hasClass("active")) {
                        $label.addClass("disabled");
                        $(this).attr("disabled", true);
                    }
                } else {
                    if($label.hasClass("disabled")){
                        $label.removeClass("disabled");
                        $(this).removeAttr("disabled");
                    }
                }
            });
        }

    }
};

Filter.prototype.buildIdsLabelsTab = function() {
    let self = this;
    if(this.isSelect()) {
        let $lioptions = self.$styledSelect.find(".filteroptions li");
        $lioptions.each(function() {
            self.idsLabelsTab[$(this).attr("data-value")] = $(this).text();
        });
    } else if(!this.isSearch()) {
        self.$checkboxes.each(function(){
            self.idsLabelsTab[$(this).val()] = $(this).parent("label").text();
        });
    }
};

Filter.prototype.activate = function () {
    if(this.isSelect() || this.isSearch()) {
        this.activeValues = "";
    } else{
        this.activeValues = [];
        this.$checkboxes = this.$domElt.find(':checkbox');
    }

    this.buildIdsLabelsTab();

    this.updateValues();
    this.changeStateListener();
    return this;
};

export default Filter;
